export enum ETimePeriod {
  DAILY = "DAILY",
  MONTHLY = "MONTHLY",
}
